import Mutations from '../../odata/mutations';

export default { ...new Mutations('taxRate'), ...new Mutations('taxRates') };
